export const environment = {
  production: false,
  urlApi: 'https://dportal-api.wba.com.br',
  urlWS: 'https://dnew-websocket.wba.com.br/ws',
  keycloak: {
    url: 'https://tauth.wba.com.br:8445',
    realm: 'portal-demo',
    clientId: 'portal-angular'
  },
  gAnalytics: '203092816',
};
